module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/ethereumjs-common/dist/genesisStates/kovan.json
// module id = 1060
// module chunks = 0 1 2